import { LitElement, html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import '../input/Input';
import '../icons/IconArrowDown';
import '../icons/IconArrowUp';
import styles from './styles';

class Table extends LitElement {
  static styles = styles;

  static properties = {
    name: { type: String },
    id: { type: String },
    ariaDescribedBy: { type: String, attribute: 'aria-describedby' },
    ariaLabel: { type: String, attribute: 'aria-label' },
    ariaInvalid: { type: String, attribute: 'aria-invalid' },
    columns: { type: Array },
    data: { type: Array },
    zebra: { type: Boolean },
    hoverHightlight: { type: Boolean, attribute: 'hover-highlight' },
    sorting: { type: Boolean },
    noDataMsg: { type: String, attribute: 'no-data-msg' },
    clickableRow: { type: Boolean, attribute: 'clickable-row' },
  };

  static internalProperties = {
    sort: { type: Object },
  };

  constructor() {
    super();
    this.type = 'text';
    this.name = '';
    this.id = undefined;
    this.ariaDescribedBy = '';
    this.ariaLabel = '';
    this.ariaInvalid = '';
    this.columns = [];
    this.data = [];
    this.zebra = false;
    this.hoverHightlight = false;
    this.sorting = false;
    this.sort = {
      columnName: '',
      sortting: false,
      type: '',
    };
    this.clickableRow = false;
    this.noDataMsg = 'No data Loaded';
  }

  #sortTab(event, key) {
    const elCell = event.target;
    const sortArr = Array.from(this.data);

    function compare(a, b) {
      const aValue = key.split('.').reduce((p, c) => p?.[c], a);
      const aFormatted = (Array.isArray(aValue) ? aValue.join(', ') : aValue).toLowerCase();

      const bValue = key.split('.').reduce((p, c) => p?.[c], b);
      const bFormatted = (Array.isArray(bValue) ? bValue.join(', ') : bValue).toLowerCase();
      if (aFormatted > bFormatted) {
        return 1;
      } if (aFormatted < bFormatted) {
        return -1;
      }
      return 0;
    }

    if (key !== this.sort.columnName || this.sort.sortting !== true) {
      sortArr.sort(compare);
      this.sort.sortting = true;
      elCell.classList.remove('sortedZyx');
      elCell.classList.add('sortedAbc');
      this.sort.type = 'sortedAbc';
    } else {
      sortArr.reverse();
      this.sort.sortting = false;
      elCell.classList.remove('sortedAbc');
      elCell.classList.add('sortedZyx');
      this.sort.type = 'sortedZyx';
    }

    this.sort.columnName = key;

    this.data = sortArr;
    this.requestUpdate('data');
  }

  #tableClassMap() {
    return {
      'table-hover-highlight': this.hoverHightlight,
      'table-stripped': this.zebra,
      'table-sorting': this.sorting,
      'table-clickable-row': this.clickableRow,
    };
  }

  render() {
    return html`
      <div class="table-container">
        ${this.data.length !== 0 ? html`
            <table
              class="table${classMap(this.#tableClassMap())}"
              tabindex="0"
              role="table"
              aria-label="${this.ariaLabel}"
            >
              <thead class="table-header" role="rowgroup" tabindex="0">
                <tr class="table-header-row" role="row">
                  ${this.columns.map((column) => html`
                      <th role="columnheader"
                        @click=${ifDefined(this.sorting && column.sort ? (e) => this.#sortTab(e, column.accessor) : undefined)}
                        title="${ifDefined(this.sorting && column.sort ? 'Toggle SortBy' : undefined)}"
                        class="${ifDefined(this.sorting && column.sort ? 'table-header-sort' : undefined)}"
                      >
                        ${column.name}
                        ${column.accessor === this.sort.columnName
                          && this.sort.type === 'sortedAbc' ? html`<tenable-icon-arrow-down class="sort-chervon"></tenable-icon-arrow-down>` : ''}
                        ${column.accessor === this.sort.columnName
                          && this.sort.type === 'sortedZyx' ? html`<tenable-icon-arrow-up class="sort-chervon"></tenable-icon-arrow-up>` : ''}
                      `)}
                      </th>
                </tr>
              </thead>
              <tbody class="table-body" role="rowgroup">
                ${this.data.map((item) => html`
                  <tr
                    class="table-row"
                    tabindex="0"
                    role="row"
                  >
                    ${this.columns.map((column) => {
    const value = column.accessor.split('.').reduce((p, c) => p?.[c], item);

    return html`
                        <td role="cell">
                          ${this.clickableRow ? html`
                            <a target="_blank" rel="noreferrer" href="${item.url}">
                              ${column?.Cell ? column.Cell(item) : html`<span>${Array.isArray(value) ? value.join(', ') : value}</span>`}
                            </a>
                          ` : html`
                            ${column?.Cell ? column.Cell(item) : html`<span>${Array.isArray(value) ? value.join(', ') : value}</span>`}
                          `}
                        </td>
                      `;
  })}
                  </tr>
                `)}
              </tbody>
            </table>
          ` : html`
          <p>${this.noDataMsg}</p>
          `}
      </div>
    `;
  }
}

customElements.define('tenable-table', Table);
